import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router";
// import * as _ from "lodash";
import { useSubscription } from "@apollo/client";

// constants
import MultiStepForm from "./MultiStepForm";
import logoLogin from "../../../image/logo_main.png";
import { SUBSCRIPTION_COMPLETED_PAYMENT_V2 } from "../../../graphql/order/mutation";
import "./checkout-theme.css";
// import { GET_ORDER_GROUPS_SHOP_SETTING } from "../../../graphql/order/query";
// import { errorSwal } from "../../../helpers/sweetalert";
// import LoadingAbsolute from "../../../components/loading/LoadingAbsolute";
// import ConfirmPaymentAuto from "./confirm_payment_auto";
// import { FaFileInvoice } from "react-icons/fa";


function OrderConfirm() {
  const { match } = useReactRouter();
  // null = ຍັງບໍ່ຮູ້ສະຖານະ (ກຳລັງໂຫຼດ) — ຢ່າຫາກໍເປີດໜ້າກໍ່ກະພິບເຕືອນໃສ່ລູກຄ້າ
  const [isPaymented, setIsPaymented] = useState(null);
  // const [orderShopSetting, setOrderShopSetting] = useState(null);
  // const [customerInfo, setCustomerInfo] = useState(false);

  // const [getOrderShopSetting, {loading: orderShopSettingLoading }] =
  //   useLazyQuery(GET_ORDER_GROUPS_SHOP_SETTING, {
  //     onCompleted: (data) => {
  //       if (data.orderGroupShopSetting?.status || data.orderGroupShopSetting?.dataOne) {
  //         setOrderShopSetting(data.orderGroupShopSetting.dataOne);
  //       } else {
  //         console.error("Create error:", data.orderGroupShopSetting?.msg || "Failed to create order group");
  //         return errorSwal(data.orderGroupShopSetting?.msg || "ເກີດຂໍ້ຜິດພາດໃນການສ້າງອໍເດີ້");
  //       }
  //     },
  //     onError: (error) => {
  //       console.error("Create error:", error.message);
  //       return errorSwal(error.message || "ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໜ່ອີກຄັ້ງ");
  //     }
  //   });

  const { data: onCompletedPaymentV2 } = useSubscription(SUBSCRIPTION_COMPLETED_PAYMENT_V2, {
    variables: {
      orderId: match?.params?.data,
    },
  });

  // subscribe completed payment
  useEffect(() => {
    if (onCompletedPaymentV2) {
      if (onCompletedPaymentV2?.onCompletedPaymentV2?.id === match?.params?.data) {
        // const orderGroup = onCompletedPaymentV2?.onCompletedPaymentV2;
        // console.log("onCompletedPaymentV2 3", orderGroup);
        // if (orderShopSetting?.isPaymentGateway && (!orderGroup?.phone || !orderGroup?.addressCf || (!orderGroup?.customerName && !orderGroup?.cfName))) {
          window.location.reload()
      }
    }
  }, [onCompletedPaymentV2]);

  // useEffect(() => {
  //   if (!match?.params?.data) return;
  //   getOrderShopSetting({
  //     variables: {
  //       where: {
  //         id: match?.params?.data,
  //       },
  //     },
  //   });
  // }, [match?.params?.data]);


  // if (orderShopSettingLoading) return <LoadingAbsolute />
  return (
    <div className="cf-checkout" style={{ position: 'relative', minHeight: '100dvh' }}>

      <header className="cf-header">
        <div className="cf-header__mark">
          <img src={logoLogin} alt="" />
        </div>
        <h1 className="cf-header__title">Super CF</h1>
        <span className="cf-header__chip">ຢືນຢັນອໍເດີ</span>
        {isPaymented === false && (
          <span className="cf-header__badge">ລົບກວນຊຳລະອໍເດີ້ນີ້</span>
        )}
      </header>

      <div className="cf-page">
        <MultiStepForm onPaymentStateChange={setIsPaymented} />
      </div>

      {/* <div style={{ padding: 5, marginBottom: "2em" }}>
        {orderShopSetting ? (<>
          {orderShopSetting?.isPaymentGateway ? <ConfirmPaymentAuto customerInfo={customerInfo} setCustomerInfo={setCustomerInfo} /> : <MultiStepForm />}
        </> )
        : (<MultiStepForm />)}
      </div> */}

      {/* <div className="tell-me-button">
          <p>bill</p>
          <button className="btn-digital-bill">
            <FaFileInvoice />
          </button>
          <p>history</p>
      </div> */}
    </div>
  );
}

export default OrderConfirm;
